import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import BackgroundWeather from '../../../domain/entities/BackgroundWeather';

export default function reducer(
  state: {[key: number]: BackgroundWeather} = {},
  action: AnyAction,
): {[key: number]: BackgroundWeather} {
  switch (action.type) {
    case Types.IndexBackgroundWeathersSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (
            obj: {[key: number]: BackgroundWeather},
            record: BackgroundWeather,
          ) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    default:
      return state;
  }
}
